<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismiss('close')">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Agregar saldo</ion-title>
    <ion-buttons slot="end">
      <ion-chip color="secondary" shape="round" fill="solid" class="balance-chip">
        &nbsp;&nbsp;<ion-icon name="wallet-outline"></ion-icon>
        <small *ngIf="!isLoading"> {{ balance | currency }}&nbsp; </small
        ><ion-spinner *ngIf="isLoading" color="secondary" name="dots"></ion-spinner>&nbsp;
      </ion-chip>
    </ion-buttons>
    <ion-progress-bar *ngIf="isLoading" type="indeterminate"></ion-progress-bar>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid class="ion-no-margin ion-no-padding">
    <ion-row>
      <ion-col sizeXs="12" sizeSm="6">
        <ion-grid class="ion-no-margin ion-no-padding">
          <ion-row class="full">
            <ion-col size="12" class="ion-no-margin ion-no-padding">
              <ion-item class="wallet-select ion-no-margin ion-padding-vertical" lines="none" button>
                <ion-thumbnail slot="start">
                  <ion-img src="./assets/wallet/wallet.png"></ion-img>
                </ion-thumbnail>
                <ion-label>
                  <h2>Cmillonario Wallet</h2>
                  <ion-skeleton-text *ngIf="isLoading" [animated]="true" style="width: 90px"></ion-skeleton-text>
                  <p *ngIf="!isLoading">
                    <i>
                      Saldo actual:
                      {{ balance | currency | slice : 0 : -3 }}<small>.{{ balance | currency | slice : -2 }}</small>
                    </i>
                  </p>
                </ion-label>

                <ion-icon color="primary" slot="end" slot="icon-only" name="caret-down-outline"></ion-icon>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row class="ion-padding-horizontal">
            <!-- <ion-col class="ion-no-padding ion-no-margin payment-selector" size="7">
              <ion-item>
                      <ion-label position="stacked">Método de pago</ion-label>
                      <ion-icon slot="start" src="./assets/icons/transaction_types/deposit.svg"></ion-icon>
                      <ion-select interface="popover" placeholder="Método de pago">
                        <ion-select-option value="credit-card">Tarjeta de crédito</ion-select-option>
                        <ion-select-option value="debit-card">Tarjeta de débito</ion-select-option>
                        <ion-select-option value="paypal">Paypal</ion-select-option>
                      </ion-select>
                    </ion-item>

              <h3 class="payment-selector-head">
                <ion-icon slot="start" src="./assets/icons/transaction_types/deposit.svg"></ion-icon>&nbsp;&nbsp;Método de
                pago
              </h3>
              <ion-item>
                <ion-icon slot="start" [src]="'./assets/wallet/payment_types/' + cardIcon + '.svg'"></ion-icon>
                <ion-select
                  aria-label="Tarjeta"
                  interface="popover"
                  [value]="cardSelected"
                  justify="space-between"
                  (ionChange)="changeCard($event.detail.value)"
                >
                  <ion-select-option value="new"> Nueva tarjeta </ion-select-option>
                  <ion-select-option *ngFor="let c of cards" [value]="c.id">
                    <ion-icon src="./assets/wallet/payment_types/amex.svg"></ion-icon>
                    {{ c.last4Digits }}
                  </ion-select-option>
                </ion-select>
              </ion-item>

              <!-- <ion-button size="small" expand="block" fill="outline" shape="round" style="margin-top: 0.7rem">
                <ion-icon slot="start" name="add"></ion-icon>
                Nueva tarjeta
              </ion-button> ->
            </ion-col> -->

            <ion-col class="ion-no-padding ion-no-margin amount-selector" size="12">
              <h3 class="amount-selector-head">
                <ion-icon slot="start" src="./assets/icons/transaction_types/prize.svg"></ion-icon>&nbsp;&nbsp;Monto a
                abonar
              </h3>
            </ion-col>
            <ion-col sizeXs="12">
              <ion-item lines="" class="ion-text-center">
                <ion-icon slot="start" name="cash-outline"></ion-icon>
                <ion-input
                  #inputAmount
                  aria-label="Monto a recargar"
                  [value]="200"
                  (ionInput)="updateAmount($event)"
                  (ionBlur)="blurInput()"
                  (ionFocus)="selectAllText($event)"
                  [min]="min"
                  [max]="max"
                >
                  <ion-icon color="medium" slot="start" name="logo-usd"></ion-icon>
                  <ion-icon color="medium" slot="end" name="pencil-outline"></ion-icon>
                  <ion-button [disabled]="!mp" fill="clear" slot="end" (click)="changeAmount()">
                    <ion-icon color="medium" slot="icon-only" name="caret-down-outline"></ion-icon>
                  </ion-button>
                </ion-input>
              </ion-item>
            </ion-col>
            <ion-col sizeXs="12">
              <ion-item>
                <ion-icon slot="start" name="ticket-outline"></ion-icon>
                <ion-input type="text" placeholder="Cupón" class="ion-text-start"></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <!-- <ion-row class="ion-padding-horizontal">
            <ion-col size="12" class="ion-padding-vertical">
              <ion-button
                (click)="continue()"
                [disabled]="isLoading"
                fill="solid"
                shape="round"
                expand="block"
                color="primary"
                size="small"
              >
                Continuar transacción
                <ion-icon slot="end" class="ion-padding-start" src="./assets/icons/transaction_types/deposit.svg"></ion-icon>
              </ion-button>
            </ion-col>
          </ion-row> -->
          <ion-row class="ion-padding payment-disclaimer">
            <ion-col size="12">
              <span class="payment-methods-icons">
                <!-- <ion-icon src="./assets/wallet/payment_types/amex.svg"></ion-icon>
                <ion-icon src="./assets/wallet/payment_types/mastercard.svg"></ion-icon>
                <ion-icon src="./assets/wallet/payment_types/visa.svg"></ion-icon>
                <ion-icon src="./assets/wallet/payment_types/paypal.svg"></ion-icon> -->
              </span>
              <span class="nuvei-tag">
                Pagos seguros por
                <ion-img src="./assets/wallet/payment_types/nuvei-dark.svg"></ion-img>
              </span>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
      <ion-col sizeXs="12" sizeSm="6" class="nuvei ion-padding-horizontal">
        <ion-grid fixed>
          <ion-row>
            <ion-col *ngIf="isLoading" size="12">
              <!-- <app-loader [isLoading]="true"></app-loader> -->
              <ion-list>
                <!-- <ion-list-header>
                  <ion-skeleton-text [animated]="true" style="width: 80px"></ion-skeleton-text>
                </ion-list-header> -->
                <ion-item *ngFor="let item of [0, 1, 2, 3, 4]">
                  <ion-thumbnail slot="start">
                    <ion-skeleton-text [animated]="true"></ion-skeleton-text>
                  </ion-thumbnail>
                  <ion-label>
                    <h3>
                      <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
                    </h3>
                    <p>
                      <ion-skeleton-text [animated]="true" style="width: 60%"></ion-skeleton-text>
                    </p>
                    <p>
                      <ion-skeleton-text [animated]="true" style="width: 30%"></ion-skeleton-text>
                    </p>
                  </ion-label>
                </ion-item>
              </ion-list>
            </ion-col>
            <ion-col [ngStyle]="{ display: isLoading ? 'none' : undefined }" size="12">
              <div id="nuvei-checkout-container" style="width: 100%; height: auto"></div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
